export default __webpack_public_path__ + "static/media/risk-identification.3037ba12.svg";